import { Component, inject, OnInit, effect } from '@angular/core';
import { Store } from '@ngxs/store';
import { GenericState } from 'src/app/store/generic.state';
import { SignupQuestionsSignal } from 'src/app/signal/signup-questions.signal';
import { filter, take } from 'rxjs/operators';
import * as _ from 'underscore';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { DecimalPipe } from '@angular/common';
import { ISignupQuestions } from 'src/app/models/signup-questions.model';

@Component({
	selector: 'app-fourth-step',
	templateUrl: './fourth-step.component.html',
	styleUrls: ['./fourth-step.component.scss'],
	imports: [NzButtonModule, DecimalPipe]
})
export class FourthStepComponent implements OnInit {
	private readonly signupQuestionsSignal = inject(SignupQuestionsSignal);
	private readonly genericActions$ = inject(Store).select(GenericState.getGeneric);

	public preferredWorkLocLabel: string = '';
	public availabilityLabel: string = '';
	public storeData: ISignupQuestions;

	private experienceOptions = [
		{ label: '0-1 year', value: 0 },
		{ label: '1-2 years', value: 1 },
		{ label: '2-3 years', value: 2 },
		{ label: '3-4 years', value: 3 },
		{ label: '5-10 years', value: 5 },
		{ label: '11 and up', value: 11 }
	];

	private genericData: any = null;

	constructor() {
		// Effect to watch state from signal
		effect(() => {
			const state = this.signupQuestionsSignal.state();
			this.storeData = state;
			
			if (this.genericData) {
				this.updateLabels();
			}
		});
	}

	public ngOnInit(): void {
		this.genericActions$.pipe(
			filter((e: any) => !_.isEmpty(e.preferredWorkSetup)),
			take(1)
		).subscribe((genericData) => {
			this.genericData = genericData;
			this.updateLabels();
		});
	}

	private updateLabels(): void {
		if (!this.genericData || !this.storeData) return;

		// Get preferred work location label
		this.preferredWorkLocLabel = this.genericData.preferredWorkSetup.find(
			(x: any) => x.id === this.storeData.salaryWorkPreference?.preferredWorkLocationId
		)?.option || '';

		// Get availability label
		if (this.genericData.availability && this.storeData.salaryWorkPreference?.workAvailabilityId) {
			this.availabilityLabel = this.genericData.availability.find(
				(x: any) => x.id === this.storeData.salaryWorkPreference?.workAvailabilityId
			)?.option || '';
		}
	}

	public moveTo(step: number): void {
		this.signupQuestionsSignal.moveToStep(step);
	}

	public getExperienceLabel(value: number | null | undefined): string {
		if (value === undefined || value === null) return '';
		return this.experienceOptions.find(e => e.value === value)?.label || '';
	}

	public getRelocationLabel(relocation: string | null | undefined): string {
		if (!relocation) return '';
		if (relocation === 'I am willing to relocate') {
			return 'Open to relocation';
		} else if (relocation === 'I am NOT willing to relocate') {
			return 'Not open to relocation';
		} else if (relocation === 'Depends on the salary') {
			return 'Depends on salary';
		}
		return relocation;
	}
}
